import {
    addSnsOauthData,
    isSnsSignUp,
    getEmail,
    getUser,
    getUserName,
    initUser,
    isWebView,
    getPlanId,
    getUserId
} from "../../store.js";
import {CompanyInfoView} from "../../company-info-view/index.js";
import {CompanyJoinWaitView} from "../../company-join-wait-view/index.js";
import {MorningmateSnsInputView} from "../../morningmate-sns-input-view/index.js";
import {MorningMateBusinessEmailInputView} from "../../morningmate-business-email-input-view/index.js";
import {BusinessEmailView} from "../../view/BusinessEmailView.js";
import {GuestEmailView} from "../../view/GuestEmailView.js";
import {EmailAuthView} from "../../view/EmailAuthView.js";
import {UserProfileView} from "../../view/UserProfileView.js";
import {CompanyInviteUserView} from "../../view/CompanyInviteUserView.js";
import {CompanyProfileView} from "../../view/CompanyProfileView.js";
import {SubDomainSearchView} from "../../view/SubDomainSearchView.js";
import {
    sendMoveMobileSignUpPage,
    mobileSignIn,
    mobileOpenShareContents
} from "../../../../bridge/renewal-signup/index.js";


const routerMap = {
    'businessEmail': {
        title: 'businessEmail',
        loadView: loadBusinessEmailView,
    }, 'guestEmail': {
        title: 'guestEmail',
        loadView: loadGuestEmailView,
    }, 'emailAuth': {
        title: 'emailAuth',
        loadView: loadEmailAuthView,
    }, 'userProfileInput': {
        title: 'userProfileInput',
        loadView: loadProfileView,
    }, 'companyInvite': {
        title: 'companyInvite',
        loadView: loadCompanyInviteView,
    }, 'searchCompanySubDomain': {
        title: 'searchCompanySubDomain',
        loadView: loadSearchCompanyBySubDomain,
    }, 'companyInfo': {
        title: 'companyInfo',
        loadView: loadCompanyInfoView
    }, 'companyInfoInput': {
        title: 'companyInfoInput',
        loadView: loadCompanyInfoInputView
    }, 'companyJoinWait': {
        title: 'companyJoinWait',
        loadView: loadCompanyJoinWaitView
    }, 'morningmateSns': {
        title: 'morningmateSns',
        loadView: loadMorningmateSnsView
    }, 'morningmateBusinessEmailInput': {
        title: 'morningmateBusinessEmailInput',
        loadView: loadMorningMateBusinessEmailInputView
    }
}

const customHistory = [];

function addBackEvent() {
    window.onpopstate = function (event) {
        if (customHistory.length <= 1) {
            Mutil.removeLocal("SNS_ACCOUNT_SETTING")
            isWebView() ? sendMoveMobileSignUpPage() : history.back();
            return;
        }
        if (isNotWorkBackButton()) {
            history.pushState({}, "", `${location.search}`);
            return;
        }
        const curPage = customHistory.pop().title;
        const prevPage = customHistory.pop().title;
        Mutil.mlog(`뒤로 가기 : ${curPage} >>> ${prevPage}`);
        if(isFirstPage(prevPage)) {
            const planId = getPlanId();
            routerMap[prevPage].loadView(planId);
            return;
        }
        routerMap[prevPage].loadView();
    };
}
function isFirstPage(routerTitle = "") {
    const firstPageTitles = ['morningmateSns' , 'businessEmail']
    return firstPageTitles.includes(routerTitle);
}

function isNotWorkBackButton() {
    return isCompanyWaitView() || isEmployeeInviteView();
}

function isEmployeeInviteView() {
    return $("#welcomeStep").is(":visible");
}

function isCompanyWaitView() {
    if (customHistory.length === 0) {
        return false;
    }
    const curPageHistory = customHistory[customHistory.length - 1];
    return curPageHistory.title === "companyJoinWait"
}

function addCustomHistory(title = "") {
    const url = `?${title}`
    history.pushState({title}, "", url);

    if (Mutil.empty(title) || !routerMap.hasOwnProperty(title)) {
        return;
    }
    customHistory.push({title});
}


function drawView(props) {
    const {
        viewModule = Mutil.noop,
        title = '',
        layer = $("")
    } = props;
    addCustomHistory(title);

    // @Todo rule 등록...
    const isChangeAll = layer.length === 0;
    if (isChangeAll) {
        emptySignUpView();
        viewModule();
        return;
    }

    viewModule(layer);
}

// 가입 이메일 입력 뷰
function loadBusinessEmailView(planId = "") {
    initUser(false, planId)
    const subText = Often.isGlobal() ? i18next.t(login.useForFreeMorningmate) : i18next.t(login.useForFree);
    drawView({
        title: 'businessEmail',
        viewModule: () => {
            new BusinessEmailView($("body"), {
                mainText : i18next.t(login.startFreeTrial),
                subText : subText,
                guestPageButtonText : i18next.t(login.startAsAGuest),
            });
        }
    });

}


// 가입 이메일 입력 뷰
function loadGuestEmailView() {
    initUser(true);
    drawView({
        title: 'guestEmail',
        viewModule: () => {
            new GuestEmailView($("body"), {
                mainText : i18next.t(login.crgstaccnt),
                subText : i18next.t(login.invtdprjct),
            });
        }
    });
}

// 이메일 인증 번호 입력 뷰
function loadEmailAuthView() {
    collectGtm("new_signup3");
    drawView({
        title: 'emailAuth',
        viewModule: () => {
            const email = getEmail();
            new EmailAuthView($("body"), {
                mainText : i18next.t(common.inputValue, {val : $t(common.confirmVerificationCode)}),
                subText : email
            })
        }
    });
}

// 사용자 정보 입력 뷰
async function loadProfileView( planId = '', snsOauthData = {}) {
    const isSnsSignUp = Object.values(snsOauthData).length > 0;
    if (isSnsSignUp) {
        !Mutil.empty(planId) && initUser(!Often.isGlobal(), planId); // 모닝 메이트만 구글 회원가입일 경우 비즈니스
        addSnsOauthData(snsOauthData);
    }
    // 구글 회원 가입이면  new_signup2_b, 일반 이메일 회원 가입이면 new_signup4
    setTimeout(() => {
        collectGtm("new_signup4");
    }, 1500);

    drawView({
        title: 'userProfileInput',
        viewModule: () => {
            const Internationalization = Mutil.requireIIFE("Internationalization");
            const isEn = Internationalization.getCurrentLanguage().toLowerCase().includes('en');
            const userId = getUserId();
            new UserProfileView($("body"), {
                mainText: i18next.t(login.inuputUserInfo),
                subText: isEn ? `start with ${userId}` : i18next.t(login.enterUserInfo),
            });
        }
    });

}


// 회사 초대 정보 뷰
function loadCompanyInviteView(inviterList = []) {
    collectGtm("new_signup5");
    drawView({
        title: 'companyInvite',
        viewModule: () => {
            const name = getUserName();
            new CompanyInviteUserView($("body"), {
                mainText: i18next.t(login.welcome, {val: `${name}`}),
                subText: i18next.t(login.startCollab),
                mainLabel: i18next.t(login.newWorkspace),
                subLabel: i18next.t(login.newCompanyTeam),
                inviterList
            });
        }
    });
}


function loadCompanyInfoInputView() {
    //@todo 입력 값 검증(user)
    collectGtm("new_signup6");
    drawView({
        title: 'companyInfoInput',
        viewModule: () => {
            new CompanyProfileView($("body"), {
                mainText: i18next.t(login.newWorkspace),
                subText: i18next.t(login.common.enter, {val: $t(common.companyName)}),
            });
        }
    });
}

function loadInviteUserView(COMPANY_INFO_JSON = {}) {
    //@todo 입력 값 검증(user)
    collectGtm("new_signup7", getEmail());
    drawView({
        title: 'inviteUser',
        viewModule: () => {
            const WelcomeStep = Mutil.requireIIFE("WelcomeStep");
            WelcomeStep.openWelcomeStep({
                ...COMPANY_INFO_JSON,
                "WEBVIEW_YN" : isWebView() ? "Y" : "N",
                mobileOpenShareContents : !isWebView() ? Mutil.noop : mobileOpenShareContents,
                mobileSignInFunc: !isWebView() ? Mutil.noop : () => {
                    mobileSignIn({...getUser().getCreateNewCompanyInfoJson()});
                }
            });
        }
    });
}

// 새 회사 정보 입력 뷰
function loadSearchCompanyBySubDomain() {
    //@todo 입력 값 검증(user)
    collectGtm("new_joinup1");
    drawView({
        title: 'searchCompanySubDomain',
        viewModule: () => {
            new SubDomainSearchView($("body"), {
                mainText: i18next.t(login.inputCompanyInfo),
                subText: i18next.t(login.enterCompanyURL),
                infoText: i18next.t(login.companyURLDesc),
            })
        }
    });
}

// 회사 정보 확인 뷰
function loadCompanyInfoView(isInvite = false) {
    //@todo 입력 값 검증(user)
    isInvite ? collectGtm("new_joinup1_a") : collectGtm("new_joinup2");
    drawView({
        title: 'companyInfo',
        viewModule: () => {
            CompanyInfoView.draw()
        }
    });
}

// 회사 가입 요쳥 완료 뷰
function loadCompanyJoinWaitView(userId = getUserId()) {
    if(Mutil.empty(userId)) {
        Mutil.toast("error", i18next.t(main.alert.wrongApproach));
        return;
    }

    //@todo 입력 값 검증(user)
    collectGtm("new_joinup3");
    drawView({
        title: 'companyJoinWait',
        viewModule: () => {
            CompanyJoinWaitView.draw({userId});
        }
    });
}

// 가입 이메일 입력 뷰
function loadMorningmateSnsView(planId) {
    initUser(false, planId);

    //기본적으로 페이지 로드되는 시점에 호출되는 함수에다가 collect하면 GA태그 자체가 안붙어서 이벤트가 캔슬되는 케이스가 생길 수 있음
    //보통 이런경우 setTimeout으로 딜레이 주고 쏘는편(main 참고)
    setTimeout(() => {
        collectGtm("new_signup1");
    }, 1500);
    drawView({
        title: 'morningmateSns',
        viewModule: () => {
            MorningmateSnsInputView.draw();
        }
    });
}

// 가입 이메일 입력 뷰
function loadMorningMateBusinessEmailInputView() {
    collectGtm("new_signup2");
    drawView({
        title: 'morningmateBusinessEmailInput',
        viewModule: () => {
            MorningMateBusinessEmailInputView.draw()
        }
    });
}

function emptySignUpView() {
    Mutil.removeLocal("SNS_ACCOUNT_SETTING");
    $("body > *:not(#welcomeStep,#popupDraw)").remove();
}

function moveSignInPage() {
    location.href = "/signin.act";
}
function moveNewSignUpPage(snsOauthData = {}) {
    const existData = Object.values(snsOauthData).length > 0;
    const isGmailOAuth = Often.null2Void(new URL(location.href).searchParams.get('gmail_workspace_oauth')).includes('true');

    if (existData) {
        Mutil.setLocalJson("SNS_ACCOUNT_SETTING",{...snsOauthData} )
    }

    if(isGmailOAuth){
        Mutil.open("/newSignup.act?account=sns", "_blank");
        return;
    }

    location.href = "/newSignup.act?account=sns";
}
function moveIndexHomePage() {
    location.href = "/";
}

function collectGtm(eventName = "", userId = "") {
    if(Mutil.empty(eventName) || !Often.isGlobal()) return ;
    const finalEventName = isSnsSignUp() ?  `${eventName}${eventName === 'new_joinup1_a' ? '' : '_'}b` : eventName;
    const GoogleTagManager = Mutil.requireIIFE("GoogleTagManager");
    GoogleTagManager?.collect({event: `${finalEventName}` , userId,});
}

export const SignUpViewChanger = {
    loadBusinessEmailView,
    loadEmailAuthView,
    loadProfileView,
    loadCompanyInviteView,
    loadCompanyInfoView,
    loadCompanyInfoInputView,
    moveSignInPage,
    loadSearchCompanyBySubDomain,
    loadCompanyJoinWaitView,
    loadGuestEmailView,
    addBackEvent,
    loadMorningmateSnsView,
    loadMorningMateBusinessEmailInputView,
    emptySignUpView,
    moveIndexHomePage,
    loadInviteUserView,
    moveNewSignUpPage,

}


